import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { Declaracion, DireccionMercaderia, DeclaracionesEntity, DeclaracionUsuario, DireccionRubroIncendio, Mercaderia } from "../entities/declaracion_entity";
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { PolizaEntity } from '../entities/polizas_cliente_entity';

@Injectable()
export class DeclaracionesService {
    private url = "declaraciones";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }
    ConsultarPolizasDeclarativas(cliente: ClienteXCiudad): Observable<DeclaracionesEntity[]> {        
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaPolizasDeclarativas", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    Declarar(declaraciones: DeclaracionUsuario): Observable<boolean> {
        let body = JSON.stringify(declaraciones);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/declarar", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    CargarDireccionesDeclarativas(poliza: DeclaracionesEntity): Observable<DireccionRubroIncendio[]> {
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/cargarDireccionesDeclarativas/", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    CargarDeclaraciones(poliza: PolizaEntity): Observable<Declaracion> {
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/cargarDeclaraciones/", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    EnviarSolicitudDeclaracion(declaraciones: DeclaracionUsuario): Observable<boolean> {
        let body = JSON.stringify(declaraciones);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/enviarSolicitudDeclaracion", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    CargarMercaderiasDeclarativas(poliza: DeclaracionesEntity): Observable<Mercaderia[]> {
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/cargarMercaderiasAseguradas/", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/declaraciones/declaraciones.service.ts